import { Pipe, PipeTransform } from '@angular/core';
import { AbstractControl } from '@angular/forms';
import { format } from 'date-fns';
import { chain } from 'lodash';

interface ConcatDateAndTimeParams {
  date: string;
  time?: string;
}

@Pipe({ name: 'concatDateAndTime' })
export class ConcatDateAndTimePipe implements PipeTransform {
  transform({ date, time }: ConcatDateAndTimeParams): string {
    if (time) {
      const value = `${date}T${time}`;
      const formattedDate = format( new Date(value), 'dd/MM/yyyy HH:mm');
      return formattedDate;
    }

    return format(new Date(date), 'dd/MM/yyyy');
  }
}
